/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useEffect, useState, useCallback } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import api from '../../services/api';

import { ModalStyle, Table } from './styles';

import LeaderBoardLogo from '../../assets/logoLeaderboard.png';
import Bitcoin from '../../assets/coins/Bitcoin.svg';
import BitcoinCash from '../../assets/coins/BitcoinCash.svg';
import BitcoinGold from '../../assets/coins/BitcoinGold.svg';
import BitcoinSV from '../../assets/coins/BitcoinSV.svg';
import Dash from '../../assets/coins/Dash.svg';
import Digibyte from '../../assets/coins/Digibyte.svg';
import Dogecoin from '../../assets/coins/Dogecoin.svg';
import Eos from '../../assets/coins/Eos.svg';
import Ethereum from '../../assets/coins/Ethereum.svg';
import EthereumClassic from '../../assets/coins/EthereumClassic.svg';
import Komodo from '../../assets/coins/Komodo.svg';
import Lisk from '../../assets/coins/Lisk.svg';
import Litecoin from '../../assets/coins/Litecoin.svg';
import Neo from '../../assets/coins/Neo.svg';
import Qtum from '../../assets/coins/Qtum.svg';
import Ripple from '../../assets/coins/Ripple.svg';
import Stellar from '../../assets/coins/Stellar.svg';
import Stratis from '../../assets/coins/Stratis.svg';
import Tether from '../../assets/coins/Tether.svg';
import Tron from '../../assets/coins/Tron.svg';
import Waves from '../../assets/coins/Waves.svg';
import Zcash from '../../assets/coins/Zcash.svg';

interface arrayValue {
  id: string;
  basebet: number;
  current_price: number;
  price: number;
  image: string;
  name: string;
  symbol: string;
}

interface DataOfBounty {
  [i: string]: string;
  id: string;
  killer: string;
  victim: string;
  rollOfVictim: string;
  rollOfKiller: string;
}

interface DataOfBounty {
  bountyId: string;
  username: string;
}

interface NumberOfKills {
  username: string;
  numberOfKills: number;
  price: string;
}

interface ArrayOfKills {
  username: string;
  numberOfKills: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const ModalBounty = (props: any) => {
  const { buttonLabel, className, modalTitle, bountyId, round } = props;

  const [arrayOfListOfKills, setArrayOfListOfKills] = useState<DataOfBounty[]>(
    [],
  );

  const [dayNow, setDayNow] = useState<string>();

  const [dataOfCurrency, setDataOfCurrency] = useState([]);
  const [currencyOfToday, setCurrencyOfDay] = useState<arrayValue[]>([]);
  const [arrayOfNumberOfKills, setArrayOfNumberOfKills] = useState<
    NumberOfKills[]
  >([]);

  const updateNumberOfRoll = useCallback(async () => {
    const response = await api.get(`/bountyRoll/${round}/${bountyId.bountyId}`);
    if (response.data[0]) {
      setDataOfCurrency(JSON.parse(response.data[0].currencies));

      const dateToday = new Date(Number(response.data[0].startBounty));
      const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ];

      setDayNow(String(days[dateToday.getDay()]));

      if (response.data[0].listOfBounty)
        setArrayOfListOfKills(JSON.parse(response.data[0].listOfBounty));
    }
  }, [bountyId.bountyId, round]);

  useEffect(() => {
    updateNumberOfRoll();
  }, [updateNumberOfRoll]);

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    const filterOfDataCurrencies = dataOfCurrency.map(
      (currency: arrayValue) => {
        if (currency.id === 'tether') {
          currency.image = Tether;
        } else if (currency.id === 'bitcoin') {
          currency.image = Bitcoin;
        } else if (currency.id === 'ethereum') {
          currency.image = Ethereum;
        } else if (currency.id === 'ripple') {
          currency.image = Ripple;
        } else if (currency.id === 'litecoin') {
          currency.image = Litecoin;
        } else if (currency.id === 'dogecoin') {
          currency.image = Dogecoin;
        } else if (currency.id === 'ethereum-classic') {
          currency.image = EthereumClassic;
        } else if (currency.id === 'bitcoin-cash') {
          currency.image = BitcoinCash;
        } else if (currency.id === 'zcash') {
          currency.image = Zcash;
        } else if (currency.id === 'digibyte') {
          currency.image = Digibyte;
        } else if (currency.id === 'eos') {
          currency.image = Eos;
        } else if (currency.id === 'stellar') {
          currency.image = Stellar;
        } else if (currency.id === 'tron') {
          currency.image = Tron;
        } else if (currency.id === 'dash') {
          currency.image = Dash;
        } else if (currency.id === 'bitcoin-cash-sv') {
          currency.image = BitcoinSV;
        } else if (currency.id === 'bitcoin-gold') {
          currency.image = BitcoinGold;
        } else if (currency.id === 'neo') {
          currency.image = Neo;
        } else if (currency.id === 'stratis') {
          currency.image = Stratis;
        } else if (currency.id === 'komodo') {
          currency.image = Komodo;
        } else if (currency.id === 'lisk') {
          currency.image = Lisk;
        } else if (currency.id === 'qtum') {
          currency.image = Qtum;
        } else if (currency.id === 'waves') {
          currency.image = Waves;
        }
        return currency;
      },
    );

    let currencyOfDay;

    switch (dayNow) {
      case 'Sunday':
        currencyOfDay = filterOfDataCurrencies.filter(
          (currency: arrayValue) => {
            return currency.id === 'dogecoin';
          },
        );
        break;
      case 'Monday':
        currencyOfDay = filterOfDataCurrencies.filter(
          (currency: arrayValue) => {
            return currency.id === 'stellar';
          },
        );
        break;
      case 'Tuesday':
        currencyOfDay = filterOfDataCurrencies.filter(
          (currency: arrayValue) => {
            return currency.id === 'litecoin';
          },
        );
        break;
      case 'Wednesday':
        currencyOfDay = filterOfDataCurrencies.filter(
          (currency: arrayValue) => {
            return currency.id === 'solana';
          },
        );
        break;
      case 'Thursday':
        currencyOfDay = filterOfDataCurrencies.filter(
          (currency: arrayValue) => {
            return currency.id === 'ethereum';
          },
        );
        break;
      case 'Friday':
        currencyOfDay = filterOfDataCurrencies.filter(
          (currency: arrayValue) => {
            return currency.id === 'tron';
          },
        );
        break;
      case 'Saturday':
        currencyOfDay = filterOfDataCurrencies.filter(
          (currency: arrayValue) => {
            return currency.id === 'binancecoin';
          },
        );
        break;
      default:
        break;
    }

    if (currencyOfDay) {
      setCurrencyOfDay(currencyOfDay);
    }
  }, [dataOfCurrency, dayNow]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const count: any = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arrayOfListOfKills.forEach(function (i: any) {
      count[i.killer] = (count[i.killer] || 0) + 1;
    });
    const countKeys = Object.keys(count);
    const countValues: number[] = Object.values(count);
    const arrayWithKeysValues = countKeys.map((key: string, index) => {
      return { username: key, numberOfKills: countValues[index] };
    });
    const arrayOrderned = arrayWithKeysValues.sort((a, b) => {
      return b.numberOfKills - a.numberOfKills;
    });

    const arrayWithKills = arrayOrderned.map((keys: ArrayOfKills) => {
      let price = '';
      if (keys.numberOfKills < 3) {
        const priceOfKills = currencyOfToday[0].basebet * 35;
        const priceOfCalc =
          Math.ceil(priceOfKills * keys.numberOfKills * 10000000) / 10000000;
        price = priceOfCalc.toFixed(7);
      } else {
        const priceOfKills = currencyOfToday[0].basebet * 35;
        const priceOfCalc =
          Math.ceil(
            (priceOfKills * keys.numberOfKills +
              (priceOfKills / 2) * (keys.numberOfKills - 2)) *
              10000000,
          ) / 10000000;

        price = priceOfCalc.toFixed(7);
      }

      return {
        username: keys.username,
        numberOfKills: keys.numberOfKills,
        price,
      };
    });

    setArrayOfNumberOfKills(arrayWithKills);
  }, [arrayOfListOfKills, currencyOfToday]);

  return (
    <>
      <Button onClick={toggle}>{buttonLabel}</Button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalStyle>
          <ModalHeader toggle={toggle}> {modalTitle}</ModalHeader>
          <ModalBody>
            <div>
              <img src={LeaderBoardLogo} alt="leaderboard" />
              <Table>
                <table>
                  <thead>
                    <tr>
                      <th>Position</th>
                      <th>Player</th>
                      <th>Kill(s)</th>
                      <th>Prize</th>
                    </tr>
                  </thead>
                  <tbody>
                    {arrayOfNumberOfKills.map((numberOfKill, number) => (
                      <tr key={numberOfKill.username}>
                        <td>{number + 1}st</td>
                        <td>{numberOfKill.username}</td>
                        <td>{numberOfKill.numberOfKills}</td>
                        <td>
                          <img
                            src={currencyOfToday[0].image}
                            alt={currencyOfToday[0].symbol}
                          />
                          {Number(numberOfKill.price).toFixed(8)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Table>
            </div>
          </ModalBody>
        </ModalStyle>
      </Modal>
    </>
  );
};

export default ModalBounty;
